import * as React from 'react';
import { FeatureFlagContext } from '../provider/provider';

/**
 * Hook to access arbitrary/multiple feature flags
 */
export function useFeatureFlags() {
  const context = React.useContext(FeatureFlagContext);

  if (!context) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagProvider');
  }

  // Re-render when overrides change
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);
  React.useEffect(() => {
    const handleOverrideChange = () => {
      forceUpdate();
    };
    window.addEventListener('flag-override-changed', handleOverrideChange);
    return () => window.removeEventListener('flag-override-changed', handleOverrideChange);
  }, []);

  return context;
}
